import { render, staticRenderFns } from "./Rarity.vue?vue&type=template&id=d24215bc"
import script from "./Rarity.vue?vue&type=script&lang=js"
export * from "./Rarity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports